import React from 'react';

import {DateRangeInput} from 'src/components/input';

import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

type Props = {
    idPrefix: string,
    label?: string,
    startDate?: string,
    endDate?: string,
    clearable?: boolean,
    onStartChange: (v?: string) => void,
    onEndChange: (v?: string) => void,
    style?: React.CSSProperties,
};

export const DateRangeFilterControl = ({
    idPrefix,
    label,
    startDate,
    endDate,
    clearable = true,
    onStartChange,
    onEndChange,
    style,
}: Props) => {
    return (
        <Group direction="v" style={style}>
            {label ? <Label htmlFor={`${idPrefix}-start`}>{label}</Label> : null}
            <DateRangeInput
                id={`${idPrefix}-start`}
                label="From"
                clearable={clearable}
                selectRangeType="start"
                startDate={startDate}
                endDate={endDate}
                onChange={onStartChange}
                width={236}
            />
            <DateRangeInput
                id={`${idPrefix}-end`}
                label="To&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                clearable={clearable}
                width={236}
                selectRangeType="end"
                startDate={startDate}
                endDate={endDate}
                onChange={onEndChange}
            />
        </Group>
    );
};

